@file:Suppress("unused", "SpellCheckingInspection")

package xim.poc.game.configuration.constants

const val itemCopperOre_640 = 640
const val itemTinOre_641 = 641
const val itemZincOre_642 = 642
const val itemIronOre_643 = 643
const val itemMythrilOre_644 = 644
const val itemDarksteelOre_645 = 645
const val itemAdamanOre_646 = 646
const val itemMolybdenumOre_647 = 647
const val itemCopperIngot_648 = 648
const val itemBronzeIngot_649 = 649
const val itemBrassIngot_650 = 650
const val itemIronIngot_651 = 651
const val itemSteelIngot_652 = 652
const val itemMythrilIngot_653 = 653
const val itemDarksteelIngot_654 = 654
const val itemAdamanIngot_655 = 655
const val itemDamascusIngot_658 = 658
const val itemTinIngot_659 = 659
const val itemAluminumOre_678 = 678
const val itemAluminumIngot_679 = 679
const val itemKhromaOre_685 = 685
const val itemImWootzIngot_686 = 686
const val itemScarletiteIngot_687 = 687
const val itemThokchaOre_734 = 734
const val itemThokchaIngot_735 = 735
const val itemSilverOre_736 = 736
const val itemGoldOre_737 = 737
const val itemPlatinumOre_738 = 738
const val itemOrichalcumOre_739 = 739
const val itemPhrygianOre_740 = 740
const val itemPBrassOre_741 = 741
const val itemPBrassIngot_742 = 742
const val itemPhGoldIngot_743 = 743
const val itemSilverIngot_744 = 744
const val itemGoldIngot_745 = 745
const val itemPlatinumIngot_746 = 746
const val itemOclIngot_747 = 747
const val itemDuriumOre_756 = 756
const val itemDuriumIngot_757 = 757
const val itemOrmoluIngot_766 = 766
const val itemFlintStone_768 = 768
const val itemRedRock_769 = 769
const val itemBlueRock_770 = 770
const val itemYellowRock_771 = 771
const val itemGreenRock_772 = 772
const val itemTranslucentRock_773 = 773
const val itemPurpleRock_774 = 774
const val itemBlackRock_775 = 775
const val itemWhiteRock_776 = 776
const val itemFulmenite_777 = 777
const val itemHeliodor_778 = 778
const val itemAventurine_779 = 779
const val itemClarite_780 = 780
const val itemLarimar_781 = 781
const val itemSelenite_782 = 782
const val itemTenebrite_783 = 783
const val itemJadeite_784 = 784
const val itemEmerald_785 = 785
const val itemRuby_786 = 786
const val itemDiamond_787 = 787
const val itemPeridot_788 = 788
const val itemTopaz_789 = 789
const val itemGarnet_790 = 790
const val itemAquamarine_791 = 791
const val itemPearl_792 = 792
const val itemBlackPearl_793 = 793
const val itemSapphire_794 = 794
const val itemLapisLazuli_795 = 795
const val itemLightOpal_796 = 796
const val itemPainite_797 = 797
const val itemTurquoise_798 = 798
const val itemOnyx_799 = 799
const val itemAmethyst_800 = 800
const val itemChrysoberyl_801 = 801
const val itemMoonstone_802 = 802
const val itemSunstone_803 = 803
const val itemSpinel_804 = 804
const val itemZircon_805 = 805
const val itemTourmaline_806 = 806
const val itemSardonyx_807 = 807
const val itemGoshenite_808 = 808
const val itemClearTopaz_809 = 809
const val itemFluorite_810 = 810
const val itemAmetrine_811 = 811
const val itemDeathstone_812 = 812
const val itemAngelstone_813 = 813
const val itemAmber_814 = 814
const val itemSphene_815 = 815
const val itemFireOre_1255 = 1255
const val itemIceOre_1256 = 1256
const val itemWindOre_1257 = 1257
const val itemEarthOre_1258 = 1258
const val itemLightningOre_1259 = 1259
const val itemWaterOre_1260 = 1260
const val itemLightOre_1261 = 1261
const val itemDarkOre_1262 = 1262
const val itemWootzIngot_1461 = 1461
const val itemGranite_1465 = 1465
const val itemWootzOre_1469 = 1469
const val itemPaktongIngot_1635 = 1635
const val itemKopparnickelOre_1650 = 1650
const val itemKunwuOre_1703 = 1703
const val itemMolybdenIngot_1711 = 1711
const val itemShakudoIngot_1738 = 1738
const val itemMobluminIngot_1858 = 1858
const val itemLuminiumOre_2228 = 2228
const val itemScintillantIngot_2275 = 2275
const val itemIngot_2283 = 2283
const val itemTrBrzIngot_2302 = 2302
const val itemAUBrassIngot_2418 = 2418
const val itemElectrumIngot_2536 = 2536
const val itemSwampOre_2763 = 2763
const val itemFoolsGoldOre_2765 = 2765
const val itemQdvSilvIngot_2841 = 2841
const val itemCobaltOre_2859 = 2859
const val itemMuculentIngot_2876 = 2876
const val itemMildewyIngot_2886 = 2886
const val itemDecayedIngot_2887 = 2887
const val itemRMuttonChop_2892 = 2892
const val itemGBlkTigerFang_2893 = 2893
const val itemTrophyShield_2894 = 2894
const val itemOversizedSock_2895 = 2895
const val itemMassiveArmband_2896 = 2896
const val itemTrInsectWing_2897 = 2897
const val itemPiceousScale_2898 = 2898
const val itemHelmofBriareus_2929 = 2929
const val itemCarabossesGem_2930 = 2930
const val itemWarpedIngot_2995 = 2995
const val itemGiltIngot_3003 = 3003
const val itemVoyageStone_3226 = 3226
const val itemVoyageCoin_3227 = 3227
const val itemVoyageJewel_3228 = 3228
const val itemVoyageCard_3229 = 3229
const val itemFlameGeode_3297 = 3297
const val itemSnowGeode_3298 = 3298
const val itemBreezeGeode_3299 = 3299
const val itemSoilGeode_3300 = 3300
const val itemThunderGeode_3301 = 3301
const val itemAquaGeode_3302 = 3302
const val itemLightGeode_3303 = 3303
const val itemShadowGeode_3304 = 3304
const val itemFulgentOre_3892 = 3892
const val itemMidriumOre_3918 = 3918
const val itemMidriumIngot_3919 = 3919
const val itemVanadiumOre_3920 = 3920
const val itemRhodiumOre_3922 = 3922
const val itemRhodiumIngot_3923 = 3923
const val itemTitaniumOre_4020 = 4020
const val itemTitaniumIngot_4021 = 4021
const val itemSnowsteelOre_4023 = 4023
const val itemAcuexOre_4042 = 4042
const val itemCorrodedOre_4046 = 4046
const val itemBismuthOre_4058 = 4058
const val itemBismuthIngot_8704 = 8704
const val itemHepatizonOre_8721 = 8721
const val itemHepatizonIngot_8722 = 8722
const val itemBerylliumOre_8723 = 8723
const val itemBerylliumIngot_8724 = 8724
const val itemRaKaznarOre_8747 = 8747
const val itemRaKaznarIngot_8748 = 8748
const val itemHaroldsOre_8974 = 8974
const val itemSpectersOre_9058 = 9058
const val itemVulcaniteOre_9075 = 9075
const val itemGravewoodLog_9076 = 9076
const val itemAshweed_9078 = 9078
const val itemEschiteOre_9130 = 9130
const val itemFernStone_9211 = 9211
const val itemNiobiumOre_9247 = 9247
const val itemNiobiumIngot_9248 = 9248
const val itemRutheniumOre_9249 = 9249
const val itemRutheniumIngot_9250 = 9250
